import { Button } from '@/components/ui/shadcn/button';
import { useCan } from '@/lib/utils';
import { Link } from '@inertiajs/react';
import { Plus } from 'lucide-react';
import { type ReactNode } from 'react';

interface CreateButtonProps {
    href?: string;
    modal?: ReactNode;
    permission?: string;
    className?: string;
    label?: string;
}

export function CreateButton({ href, modal, permission, className, label }: CreateButtonProps) {
    const { can } = useCan();

    // If permission is required and user doesn't have it, don't render
    if (permission && !can(permission)) {
        return null;
    }

    // If modal is provided, render it directly (modal should handle its own trigger)
    if (modal) {
        return <>{modal}</>;
    }

    // Otherwise, render Link button
    if (href) {
        const hasLabel = Boolean(label && label.trim().length > 0);

        return (
            <Button
                size={hasLabel ? 'sm' : 'icon'}
                className={`${hasLabel ? 'h-10 gap-2 px-3' : 'h-10 w-10'} transition-shadow hover:shadow-md ${className || ''}`}
                asChild
            >
                <Link href={href}>
                    <Plus className="h-5 w-5" />
                    {hasLabel ? <span>{label}</span> : null}
                </Link>
            </Button>
        );
    }

    return null;
}
